// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const CampaignType = {
  "PRINT": "PRINT",
  "DIGITAL": "DIGITAL"
};

const CampaignAutomaticStatus = {
  "AWAITING_DELIVERY": "AWAITING_DELIVERY",
  "PARTIALLY_DELIVERED": "PARTIALLY_DELIVERED",
  "DELIVERED": "DELIVERED",
  "COPY_MISSING": "COPY_MISSING",
  "CAP_PENDING": "CAP_PENDING",
  "CAP_APPROVED": "CAP_APPROVED",
  "CAP_REJECTED": "CAP_REJECTED",
  "CAP_PARTIALLY_REJECTED": "CAP_PARTIALLY_REJECTED",
  "API_ERROR": "API_ERROR",
  "API_PENDING": "API_PENDING",
  "API_PARTIALLY_REJECTED": "API_PARTIALLY_REJECTED",
  "API_REJECTED": "API_REJECTED",
  "API_APPROVED": "API_APPROVED",
  "ZIP_DELIVERED": "ZIP_DELIVERED",
};

const CampaignStatus = {
  "AWAITING_DELIVERY": "AWAITING_DELIVERY",
  "PARTIALLY_DELIVERED": "PARTIALLY_DELIVERED",
  "DELIVERED": "DELIVERED",
  "COPY_MISSING": "COPY_MISSING",
  "CHECKED": "CHECKED",
  "SENT_TO_PRINT": "SENT_TO_PRINT",
  "SCHEDULED": "SCHEDULED",
  "CANCELLED": "CANCELLED",
  "ARCHIVED": "ARCHIVED",
  "CAP_PENDING": "CAP_PENDING",
  "CAP_APPROVED": "CAP_APPROVED",
  "CAP_REJECTED": "CAP_REJECTED",
  "CAP_PARTIALLY_REJECTED": "CAP_PARTIALLY_REJECTED",
  "API_ERROR": "API_ERROR",
  "API_PENDING": "API_PENDING",
  "API_PARTIALLY_REJECTED": "API_PARTIALLY_REJECTED",
  "API_REJECTED": "API_REJECTED",
  "API_APPROVED": "API_APPROVED",
  "ZIP_DELIVERED": "ZIP_DELIVERED",
  "APPROVED": "APPROVED",
  "REJECTED": "REJECTED"
};

const AgencyType = {
  "PRINT_SERVICE": "PRINT_SERVICE",
  "DIGITAL_SERVICE": "DIGITAL_SERVICE",
  "MEDIA_AGENCY": "MEDIA_AGENCY"
};

const AssetStatus = {
  "ARRIVED": "ARRIVED",
  "QC_CAUTION": "QC_CAUTION",
  "QC_FAILED": "QC_FAILED",
  "QC_OK": "QC_OK",
  "QC_PENDING": "QC_PENDING",
  "APPROVED": "APPROVED",
  "DECLINED": "DECLINED",
  "PENDING": "PENDING",
  "REJECTED": "REJECTED",
  "PARTIALLY_REJECTED": "PARTIALLY_REJECTED",
  "ZIP_OK": "ZIP_OK",
};

const ResolutionType = {
  "IMAGE": "IMAGE",
  "IMAGE_AND_VIDEO": "IMAGE_AND_VIDEO"
};

const { Campaign, Agency, Asset, CampaignPrintSize, PrintSize, CampaignRequiredResolution, RequiredResolution, NativeResolution, CampaignNativeResolution } = initSchema(schema);

export {
  Campaign,
  Agency,
  Asset,
  CampaignPrintSize,
  PrintSize,
  CampaignRequiredResolution,
  RequiredResolution,
  NativeResolution,
  CampaignNativeResolution,
  CampaignType,
  CampaignAutomaticStatus,
  CampaignStatus,
  AgencyType,
  AssetStatus,
  ResolutionType
};